module.exports = __webpack_public_path__ + "static/media/profile-placeholder.16467414.svg";